@if (!key) {
  <dx-select-box
    #dxSelectBox
    width="{{ width }}"
    height="{{ height }}"
    [items]="data"
    [showClearButton]="showClearButton"
    (onValueChanged)="onValueChanged($event)"
    [ngClass]="cssClass"
    [value]="value"
    placeholder="{{ placeholder }}"
    [dropDownOptions]="dropDownOptions"
    [searchEnabled]="searchEnabled"
    (onFocusOut)="onFocusOut()"
  >
    <div *dxTemplate="let data of 'dropDownButton'">
      <img alt="Custom icon" src="assets/img/chevron-down-med.svg" class="custom-select-system-icon" />
    </div>
  </dx-select-box>
}

@if (key) {
  <dx-select-box
    #dxSelectBox
    width="{{ width }}"
    height="{{ height }}"
    displayExpr="{{ key }}"
    valueExpr="{{ key }}"
    [dataSource]="data"
    [disabled]="disabled"
    [showClearButton]="showClearButton"
    [value]="value"
    placeholder="{{ placeholder }}"
    (onValueChanged)="onValueChanged($event)"
    [dropDownOptions]="dropDownOptions"
    [searchEnabled]="searchEnabled"
    (onFocusOut)="onFocusOut()"
  >
    <div *dxTemplate="let data of 'dropDownButton'">
      <img alt="Custom icon" src="assets/img/chevron-down-med.svg" class="custom-select-system-icon" />
    </div>
  </dx-select-box>
}
